import React from "react";
import { Modal, Select } from "antd";
const { Option } = Select;

export const AddOwnerModal = ({
  title,
  open,
  handleCancel,
  handleChange,
  data,
  handleSave,
}) => {
  return (
    <div>
      <Modal
        visible={open}
        footer={null}
        onOk={handleCancel}
        onCancel={handleCancel}
        closable={false}
        centered
      >
        <div style={{ display: "flex", gap: "1rem", alignItems: "center" }}>
          <h3 className="modaltitle">{title}</h3>
        </div>
        <div className="inputTitle" style={{ margin: "1rem 0px" }}>
          Add any person (e.g., ‘John Smith’), group (‘John & Jane Smith’), or
          legal entity (‘Smith Family Trust’) that owns an asset or liability.
          This list will appear in dropdown menus throughout the platform.
        </div>
        <div
          style={{
            maxHeight: "25rem",
            overflow: "scroll",
            padding: "8px",
          }}
        >
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">
              Name <span style={{ color: "red" }}>*</span>
            </h3>
            <input
              className="roleInput"
              placeholder="Name"
              name="Name"
              value={data && data.Name}
              id="Name"
              onChange={(e) => {
                e.preventDefault();
                handleChange("Name", e.target.value);
              }}
            />
          </div>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">
              Select Type <span style={{ color: "red" }}>*</span>
            </h3>
            <Select
              showSearch
              placeholder="Select Type"
              value={data && data.Type}
              onChange={(value, id) => {
                console.log("value", value);
                handleChange("Type", value);
              }}
            >
              {[
                "Individual",
                "Joint",
                "Trust (Revocable)",
                "Trust (Irrevocable)",
                "LLC/Patnership",
                "Corporation",
                "Other",
              ].map((item, index) => (
                <Option key={index} value={item}>
                  {item}
                </Option>
              ))}
            </Select>
          </div>
        </div>
        <div className="buttonsMain">
          <button
            className="cancelbutton"
            onClick={() => {
              handleCancel();
            }}
          >
            Cancel
          </button>
          <button
            className="savebutton"
            disabled={!data || !data.Name || !data.Type}
            onClick={() => {
              handleSave();
            }}
          >
            Save
          </button>
        </div>
      </Modal>
    </div>
  );
};
